<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="pink--text">Astro Details</span>
        <v-spacer></v-spacer> <v-icon class="red--text" @click="$emit('closeInfo')">mdi-close</v-icon></v-card-title>
      <v-form @submit.prevent="submitForm" class="pa-2">
        <v-row>
          <v-col cols="12" md="3">
            <v-select v-model="dosham" :items="LookupArr(dropDownList?.dhosamList)" item-text="text"
              item-value="value" label="Manglik/Chevvai Dosham"></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="astro.dob" label="Astro DOB" prepend-inner-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="astro.dob" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu ref="menu" v-model="timepicker" :close-on-content-click="false" :nudge-right="40"
              :return-value.sync="time" transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="astro.tob" label="Time of Birth (TOB)"
                  prepend-inner-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-time-picker v-if="timepicker" v-model="astro.tob" full-width
                @click:minute="$refs.menu.save(time)"></v-time-picker>
            </v-menu>
            <!-- <v-text-field v-model="astro.tob" label="Time of Birth (TOB)"></v-text-field> -->
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete v-model="cob" :items="LookupArr(dropDownList?.districtList)" item-text="text"
              item-value="value" label="City of Birth (COB)"></v-autocomplete>
          </v-col>
          <v-col cols="12" md="12" class="d-flex justify-end">
            <v-btn type="submit" class="primary elevation-0"> Submit</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Indicator: "astro",
      menu2: false,
      timepicker: false,
      time:"",
      dosham:"",
      dob:"",
      tob:"",
      cob:"",

    };
  },
  props: {
    astro: {}, dropDownList: {}
  },
  methods: {
    assignValue() {
this.dosham =  this.getKeyByValue(this.dropDownList.dhosamList, this.astro.dosham)
 this.cob  = this.getKeyByValue(this.dropDownList.districtList, this.astro.cob)?.toUpperCase();
},
    submitForm() {
      this.astro.dhosham = this.dosham
      this.astro.cob = this.cob
      this.$emit("astro", this.Indicator)
      // Handle form submission logic here, e.g., send data to an API or update the state
    },
    
  
 },
 mounted() {
    this.assignValue()
  }
};
</script>
